module.exports = __webpack_public_path__ + "static/media/image8.2bc89b36.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/carAuthorization/img/image8.png
// module id = 331
// module chunks = 0